export const MIN_SHIFT_OFFSET = 10 * 60 * 1000; // 10 minutes
